<!--
<template>
  <div class="payment-mask">

    <div class="payment-dialog">

      &lt;!&ndash; 成功 &ndash;&gt;
      <template v-if="payResult==='success'">

        <div class="success-icon">
          ✓
        </div>

        <h2 class="dialog-title">
          Payment Successful
        </h2>

        <p class="success-text">
          Your payment has been completed successfully.
        </p>

      </template>

      &lt;!&ndash; 失败 &ndash;&gt;
      <template v-else>

        <div class="failed-icon">
          ×
        </div>

        <h2 class="dialog-title">
          Payment Failed
        </h2>

        <p class="reason">
          {{ resultData.reason || 'Payment Failed' }}
        </p>

      </template>

      &lt;!&ndash; 处理中 &ndash;&gt;
      <template v-else-if="payResult==='processing'">

        <div class="processing-icon">
          <div class="spinner"></div>
        </div>

        <h2 class="dialog-title">
          Payment Processing
        </h2>

        <p class="success-text">
          Your payment is currently being processed.
        </p>

        <p class="success-text">
          Please wait a moment while we confirm the payment result.
        </p>

      </template>


      <div class="dialog-info">

        <div class="info-item">
          <span class="label">Order No</span>
          <span>{{ resultData.orderNo }}</span>
        </div>

        <div class="info-item">
          <span class="label">Amount</span>
          <span>{{ resultData.amount }} {{ resultData.currency }}</span>
        </div>

        <div class="info-item">
          <span class="label">Acquirer</span>
          <span>{{ resultData.billName }}</span>
        </div>

      </div>

&lt;!&ndash;      <button
          class="submit-btn"
          @click="goHome">

        Back

      </button>&ndash;&gt;

    </div>

  </div>
</template>

<script>

export default {

  name: "PayResult",

  data() {

    return {

      //payResult: "failed",
      payResult: "processing",

      resultData: {

        orderNo: "",

        amount: "",

        currency: "",

        billName: "",

        reason: ""

      }

    }

  },

  created() {

    const query = this.$route.query;

    const code = query.code || "";

    if (code === "1") {
      this.payResult = "success";
    } else if (code === "-1") {
      this.payResult = "processing";
    } else {
      this.payResult = "failed";
    }

    this.resultData = {
      orderNo: query.orderNo || "",
      amount: query.amount || "",
      currency: query.currency || "",
      billName: query.billName || "",
      reason: query.msg || ""
    };

  },

  methods:{

    goHome(){

      this.$router.replace("/");

    }

  }

}

</script>

<style scoped>

.payment-mask{

  position:fixed;

  left:0;

  right:0;

  top:0;

  bottom:0;

  background:#f5f7fa;

  display:flex;

  align-items:center;

  justify-content:center;

}

.payment-dialog{

  width:450px;

  background:#fff;

  border-radius:16px;

  padding:35px;

  box-shadow:0 20px 60px rgba(0,0,0,.18);

  text-align:center;

}

.success-icon{

  width:80px;

  height:80px;

  margin:auto;

  border-radius:50%;

  background:#52c41a;

  color:#fff;

  display:flex;

  justify-content:center;

  align-items:center;

  font-size:42px;

}

.failed-icon{

  width:80px;

  height:80px;

  margin:auto;

  border-radius:50%;

  background:#ff4d4f;

  color:#fff;

  display:flex;

  justify-content:center;

  align-items:center;

  font-size:42px;

}

.dialog-title{

  margin:20px 0;

}

.success-text{

  color:#666;

}

.reason{

  color:#ff4d4f;

}

.dialog-info{

  margin:30px 0;

  text-align:left;

}

.info-item{

  display:flex;

  justify-content:space-between;

  margin:12px 0;

}

.label{

  font-weight:bold;

}

.submit-btn{

  width:100%;

  height:42px;

  border:none;

  border-radius:6px;

  color:#fff;

  background:#409EFF;

  cursor:pointer;

}


.processing-icon{

  width:80px;

  height:80px;

  margin:auto;

  display:flex;

  align-items:center;

  justify-content:center;

}

.spinner{

  width:60px;

  height:60px;

  border:6px solid #e8e8e8;

  border-top:6px solid #409EFF;

  border-radius:50%;

  animation:loading 1s linear infinite;

}

@keyframes loading{

  from{
    transform:rotate(0deg);
  }

  to{
    transform:rotate(360deg);
  }

}

</style>-->
<template>
  <div class="pay-result" :class="'state-' + payResult">

    <!-- 背景层 -->
    <div class="bg-base"></div>
    <div class="bg-dots"></div>
    <div class="bg-glow"></div>
    <div class="bg-orb orb-a"></div>
    <div class="bg-orb orb-b"></div>

    <div class="receipt">
      <div class="result-card">
        <div class="card-accent"></div>

        <!-- 状态图标 -->
        <div class="status-zone">
          <div v-if="payResult === 'success'" class="status-icon success">
            <svg viewBox="0 0 52 52" class="mark-svg">
              <path class="mark-path check" d="M14 27l8.5 8.5L38 19"
                    fill="none" stroke="#fff" stroke-width="5"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>

          <div v-else-if="payResult === 'processing'" class="status-icon processing">
            <div class="ring"></div>
          </div>

          <div v-else-if="payResult === 'failed'" class="status-icon failed">
            <svg viewBox="0 0 52 52" class="mark-svg">
              <path class="mark-path cross" d="M17 17l18 18M35 17L17 35"
                    fill="none" stroke="#fff" stroke-width="5"
                    stroke-linecap="round"/>
            </svg>
          </div>

          <div v-else class="status-icon invalid">!</div>
        </div>

        <p class="status-kicker">{{ statusMeta.kicker }}</p>
        <h1 class="status-title">{{ statusMeta.title }}</h1>
        <p class="status-sub">{{ statusMeta.sub }}</p>

        <!-- 金额 -->
        <div v-if="resultData.amount" class="amount-hero">
          <span class="amount-value">{{ resultData.amount }}</span>
          <span class="amount-currency">{{ resultData.currency }}</span>
        </div>

        <!-- 明细 -->
        <div class="details">
          <div class="detail-row">
            <span class="detail-label">Order No</span>
            <span class="detail-value-group">
              <span class="detail-value mono">{{ resultData.orderNo || '—' }}</span>
              <button v-if="resultData.orderNo"
                      class="copy-btn"
                      :class="{ copied: copied }"
                      @click="copyOrderNo">
                {{ copied ? 'Copied ✓' : 'Copy' }}
              </button>
            </span>
          </div>

          <div v-if="resultData.billName" class="detail-row">
            <span class="detail-label">Acquirer</span>
            <span class="detail-value">{{ resultData.billName }}</span>
          </div>

          <div class="detail-row">
            <span class="detail-label">Time</span>
            <span class="detail-value mono">{{ payTime }}</span>
          </div>
        </div>

        <!-- 失败原因 / 提示 -->
        <div v-if="payResult === 'failed'" class="note-box failed-note">
          <strong>Reason</strong>
          {{ resultData.reason || 'Payment was declined. Please try again or use another payment method.' }}
        </div>

<!--    处理    -->
        <div v-if="payResult === 'processing'" class="note-box processing-note">
          We are confirming your payment with the bank.
          This usually takes a few seconds — please do not close this page.
        </div>

        <div v-if="payResult === 'invalid'" class="note-box invalid-note">
          The payment callback did not return a valid result.
          Please check your order status or contact support.
        </div>

        <!-- 操作 -->
<!--        <div class="actions">
          <button class="btn-primary" @click="goHome">{{ btnLabel }}</button>
          <p class="actions-hint">You will be redirected automatically</p>
        </div>-->
      </div>

      <!-- 小票撕边 -->
      <div class="receipt-tail"></div>
    </div>

  </div>
</template>

<script>
export default {
  name: "PayResult",

  data() {
    return {
      payResult: "processing",
      resultData: {
        orderNo: "",
        amount: "",
        currency: "",
        billName: "",
        reason: ""
      },
      payTime: "",
      copied: false,
      countdown: 8,
      timer: null
    };
  },

  computed: {
    statusMeta() {
      const map = {
        /*成功*/
        success: {
          kicker: "Payment Confirmed",
          title: "Payment Successful",
          sub: "Your payment has been completed successfully."
        },
        /*处理*/
        processing: {
          kicker: "Awaiting Confirmation",
          title: "Payment Processing",
          sub: "Your payment is currently being processed."
        },
        /*失败*/
        failed: {
          kicker: "Payment Declined",
          title: "Payment Failed",
          sub: "Unfortunately your payment could not be completed."
        },
        invalid: {
          kicker: "Callback Error",
          title: "Result Unavailable",
          sub: "We could not read the payment result from the callback."
        }
      };
      return map[this.payResult] || map.invalid;
    },

    btnLabel() {
      if (this.payResult === "processing" || this.payResult === "invalid") {
        return "Back to Home";
      }
      return this.countdown > 0
          ? "Back to Home (" + this.countdown + "s)"
          : "Back to Home";
    }
  },

  created() {
    const query = this.$route.query || {};

    // 同时兼容「支付网关直连参数」和「原后端重定向参数」
    const code = (query.orderStatus || query.code || "").toString().trim();

    if (code === "1") {
      this.payResult = "success";
    } else if (code === "-1") {
      this.payResult = "processing";
    } else if (code === "") {
      this.payResult = "invalid";   // 没有任何状态码 → 无效回调，不再误判为失败
    } else {
      this.payResult = "failed";
    }

    this.resultData = {
      orderNo: query.orderNo || "",
      amount: query.orderAmount || query.amount || "",
      currency: query.orderCurrency || query.currency || "",
      billName: query.acquirer || query.billName || "",
      reason: query.orderInfo || query.msg || ""
    };

    this.payTime = this.formatNow();
  },

  mounted() {
    // 成功/失败才自动跳转；处理中不跳，避免用户错过结果
  /*  if (this.payResult === "success" || this.payResult === "failed") {
      this.startCountdown();
    }*/
  },

  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },

  methods: {
    formatNow() {
      const d = new Date();
      const p = function (n) { return n < 10 ? "0" + n : "" + n; };
      // 保留原后端的 dd/MM/yyyy 风格
      return p(d.getDate()) + "/" + p(d.getMonth() + 1) + "/" + d.getFullYear() +
          " " + p(d.getHours()) + ":" + p(d.getMinutes()) + ":" + p(d.getSeconds());
    },

    startCountdown() {
      this.timer = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.timer = null;
          this.goHome();
        }
      }, 1000);
    },

    copyOrderNo() {
      const text = this.resultData.orderNo;
      if (!text) return;
      const self = this;
      const done = function () {
        self.copied = true;
        setTimeout(function () { self.copied = false; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(function () {
          self.fallbackCopy(text, done);
        });
      } else {
        this.fallbackCopy(text, done);
      }
    },

    fallbackCopy(text, done) {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand("copy"); done(); } catch (e) { /* ignore */ }
      document.body.removeChild(ta);
    },

    goHome() {
      if (this.timer) clearInterval(this.timer);
      this.$router.replace("/");
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Archivo:wght@600;700;800&family=IBM+Plex+Sans:wght@400;500;600&family=IBM+Plex+Mono:wght@400;500&display=swap');

/* ========== 状态主题色 ========== */
.pay-result {
  --accent: #0ea5a5;
  --accent-deep: #0b7d72;
  --glow: rgba(14, 165, 150, .3);
}
.state-success    { --accent: #00a870; --accent-deep: #007853; --glow: rgba(0, 168, 112, .32); }
.state-failed     { --accent: #e5484d; --accent-deep: #b02a30; --glow: rgba(229, 72, 77, .30); }
.state-processing { --accent: #f5a524; --accent-deep: #b45309; --glow: rgba(245, 165, 36, .30); }
.state-invalid    { --accent: #64748b; --accent-deep: #475569; --glow: rgba(100, 116, 139, .30); }

/* ========== 布局 & 背景 ========== */
/*.pay-result {
  position: fixed;
  left: 0; right: 0; top: 0; bottom: 0;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 36px 16px;
  font-family: 'IBM Plex Sans', -apple-system, 'Segoe UI', sans-serif;
  background: #0d2721;
}*/
.pay-result {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  overflow-y: auto;

  display:flex;
  align-items:center;
  justify-content:center;

  padding:36px 16px;

  font-family:
      'IBM Plex Sans',
      -apple-system,
      'Segoe UI',
      sans-serif;

  background:
      linear-gradient(
          135deg,
          #f5f9ff 0%,
          #eef7f5 45%,
          #fdfdfd 100%
      );
}

.bg-base, .bg-dots, .bg-glow { position: absolute; left: 0; right: 0; top: 0; bottom: 0; pointer-events: none; }
/*.bg-base {
  background: linear-gradient(165deg, #12402f 0%, #0d2a22 55%, #081c17 100%);
}*/
.bg-base {

  background:
      radial-gradient(
          circle at top left,
          rgba(14,165,165,.18),
          transparent 40%
      ),

      radial-gradient(
          circle at bottom right,
          rgba(64,158,255,.18),
          transparent 45%
      ),

      linear-gradient(
          135deg,
          #f8fbff,
          #eef8f5
      );

}
/*.bg-dots {
  background-image: radial-gradient(rgba(255, 255, 255, .06) 1px, transparent 1px);
  background-size: 22px 22px;
}*/
.bg-dots {

  background-image:
      radial-gradient(
          rgba(15,23,42,.06) 1px,
          transparent 1px
      );

  background-size:24px 24px;

}
.bg-glow {
  background: radial-gradient(640px circle at 50% -8%, var(--glow), transparent 70%);
}
/*.bg-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(70px);
  opacity: .5;
  background: var(--glow);
  pointer-events: none;
}*/
.bg-orb {

  position:absolute;

  border-radius:50%;

  filter:blur(80px);

  opacity:.35;

  background:#14b8a6;

  pointer-events:none;

}
.orb-a { width: 340px; height: 340px; left: -120px; bottom: -80px; animation: float 9s ease-in-out infinite; }
.orb-b { width: 260px; height: 260px; right: -90px; top: 10%; animation: float 11s ease-in-out infinite reverse; }

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-26px); }
}

/* ========== 小票卡片 ========== */
.receipt { position: relative; z-index: 1; width: 430px; max-width: 100%; }

.result-card {
  position: relative;
  overflow: hidden;
  background: #fffdf9;
  border-radius: 18px 18px 6px 6px;
  padding: 42px 34px 28px;
  box-shadow: 0 30px 80px rgba(0, 0, 0, .45);
  animation: cardIn .6s cubic-bezier(.22, 1, .36, 1) both;
  text-align: center;
}
.card-accent {
  position: absolute; top: 0; left: 0; right: 0; height: 6px;
  background: linear-gradient(90deg, var(--accent), var(--accent-deep));
}
.receipt-tail {
  height: 14px;
  margin: 0 10px;
  background:
      linear-gradient(-45deg, #fffdf9 7px, transparent 0),
      linear-gradient(45deg, #fffdf9 7px, transparent 0);
  background-position: left bottom;
  background-repeat: repeat-x;
  background-size: 14px 14px;
  filter: drop-shadow(0 16px 26px rgba(0, 0, 0, .3));
  animation: cardIn .6s .06s cubic-bezier(.22, 1, .36, 1) both;
}

@keyframes cardIn {
  from { opacity: 0; transform: translateY(26px) scale(.96); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

/* ========== 状态图标 ========== */
.status-icon {
  width: 88px; height: 88px;
  margin: 4px auto 0;
  border-radius: 50%;
  position: relative;
  display: flex; align-items: center; justify-content: center;
}
.status-icon.success,
.status-icon.failed {
  background: linear-gradient(145deg, var(--accent), var(--accent-deep));
  box-shadow: 0 12px 30px var(--glow);
  animation: pop .5s cubic-bezier(.34, 1.56, .64, 1) .15s both;
}
.status-icon.invalid {
  background: linear-gradient(145deg, var(--accent), var(--accent-deep));
  box-shadow: 0 12px 30px var(--glow);
  color: #fff;
  font-family: 'Archivo', sans-serif;
  font-size: 44px; font-weight: 800;
  animation: pop .5s cubic-bezier(.34, 1.56, .64, 1) .15s both;
}
.status-icon.processing {
  background: #fff7ea;
  border: 1px solid #fde7c2;
  animation: pop .5s cubic-bezier(.34, 1.56, .64, 1) .15s both;
}

/* 成功涟漪 */
.status-icon.success::before,
.status-icon.success::after {
  content: "";
  position: absolute; left: 0; right: 0; top: 0; bottom: 0;
  border-radius: 50%;
  border: 2px solid var(--accent);
  opacity: 0;
  animation: ripple 2.2s ease-out 1s infinite;
}
.status-icon.success::after { animation-delay: 2.1s; }

@keyframes ripple {
  0%   { transform: scale(1);   opacity: .55; }
  100% { transform: scale(1.9); opacity: 0; }
}

.mark-svg { width: 46px; height: 46px; }
.mark-path { stroke-dashoffset: 0; }
.mark-path.check { stroke-dasharray: 36; stroke-dashoffset: 36; animation: draw .35s ease .55s forwards; }
.mark-path.cross { stroke-dasharray: 52; stroke-dashoffset: 52; animation: draw .45s ease .55s forwards; }

@keyframes draw { to { stroke-dashoffset: 0; } }
@keyframes pop {
  from { opacity: 0; transform: scale(.4); }
  to   { opacity: 1; transform: scale(1); }
}

.ring {
  width: 52px; height: 52px;
  border-radius: 50%;
  border: 5px solid #f3dfb8;
  border-top-color: var(--accent);
  animation: spin 1s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* ========== 文案 ========== */
.status-kicker {
  margin: 22px 0 0;
  font-size: 11px; font-weight: 600;
  letter-spacing: .22em; text-transform: uppercase;
  color: var(--accent-deep);
  animation: rise .5s .25s both;
}
.status-title {
  margin: 8px 0 6px;
  font-family: 'Archivo', sans-serif;
  font-size: 31px; font-weight: 800;
  letter-spacing: -.01em;
  color: #14231f;
  animation: rise .5s .32s both;
}
.status-sub {
  margin: 0;
  font-size: 14px; line-height: 1.6;
  color: #6b7a75;
  animation: rise .5s .4s both;
}

/* ========== 金额 ========== */
.amount-hero {
  display: flex; align-items: baseline; justify-content: center; gap: 8px;
  margin: 22px 0 4px;
  padding: 16px 0;
  border-top: 1.5px dashed #e3dcd0;
  border-bottom: 1.5px dashed #e3dcd0;
  animation: rise .5s .48s both;
}
.amount-value {
  font-family: 'Archivo', sans-serif;
  font-size: 46px; font-weight: 800;
  letter-spacing: -.02em;
  color: #14231f;
  font-variant-numeric: tabular-nums;
}
.amount-currency {
  font-size: 14px; font-weight: 600;
  letter-spacing: .08em; text-transform: uppercase;
  color: #8a968f;
}

/* ========== 明细 ========== */
.details { margin-top: 16px; text-align: left; }
.detail-row {
  display: flex; justify-content: space-between; align-items: center; gap: 16px;
  padding: 11px 10px;
  border-radius: 8px;
  border-bottom: 1px dashed #e8e1d5;
  transition: background .25s;
  animation: rise .5s both;
}
.detail-row:last-child { border-bottom: none; }
.detail-row:hover { background: rgba(0, 0, 0, .035); }
.detail-row:nth-child(1) { animation-delay: .55s; }
.detail-row:nth-child(2) { animation-delay: .63s; }
.detail-row:nth-child(3) { animation-delay: .71s; }

.detail-label {
  flex-shrink: 0;
  font-size: 11px; font-weight: 600;
  letter-spacing: .14em; text-transform: uppercase;
  color: #93a09a;
}
.detail-value-group { display: flex; align-items: center; gap: 8px; min-width: 0; }
.detail-value {
  font-size: 14px; font-weight: 600;
  color: #22322c;
  text-align: right;
  word-break: break-all;
}
.detail-value.mono { font-family: 'IBM Plex Mono', monospace; font-size: 13px; }

.copy-btn {
  flex-shrink: 0;
  border: 1px solid #d8d2c4;
  background: #fff;
  color: #5c6b64;
  font-family: inherit;
  font-size: 11px; font-weight: 600;
  padding: 4px 10px;
  border-radius: 999px;
  cursor: pointer;
  transition: all .2s;
}
.copy-btn:hover { border-color: var(--accent); color: var(--accent-deep); }
.copy-btn.copied { border-color: var(--accent); background: var(--accent); color: #fff; }

/* ========== 提示块 ========== */
.note-box {
  margin-top: 16px;
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 13px; line-height: 1.55;
  text-align: left;
  animation: rise .5s .6s both;
}
.note-box strong {
  display: block;
  font-size: 11px;
  letter-spacing: .12em; text-transform: uppercase;
  margin-bottom: 4px;
}
.failed-note     { background: #fdf1f1; border: 1px solid #f6d4d6; color: #b02a30; }
.processing-note { background: #fff8ea; border: 1px solid #f5e3bd; color: #92600c; }
.invalid-note    { background: #f4f6f8; border: 1px solid #dde3ea; color: #475569; }

/* ========== 按钮 ========== */
.actions { margin-top: 24px; animation: rise .5s .7s both; }
.btn-primary {
  width: 100%; height: 48px;
  border: none; border-radius: 10px;
  background: linear-gradient(135deg, var(--accent), var(--accent-deep));
  color: #fff;
  font-family: 'Archivo', sans-serif;
  font-size: 15px; font-weight: 700; letter-spacing: .02em;
  cursor: pointer;
  box-shadow: 0 10px 24px var(--glow);
  transition: transform .2s, box-shadow .2s, filter .2s;
}
.btn-primary:hover { transform: translateY(-2px); box-shadow: 0 16px 32px var(--glow); filter: brightness(1.06); }
.btn-primary:active { transform: translateY(0) scale(.98); }
.actions-hint { margin: 10px 0 0; font-size: 12px; color: #93a09a; }

@keyframes rise {
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
  * { animation-duration: .01ms !important; animation-iteration-count: 1 !important; transition-duration: .01ms !important; }
}
</style>



// WEBPACK FOOTER //
// src/view/payment/PayResult.vue